import {SurveyId} from 'common/models/survey';
import {generatePath} from 'react-router-dom';

const {routes, preview, basePath} = window.YC;

const surveyPath = {
    success: routes.successPath,
};

export type Path = keyof typeof surveyPath;

interface GetSurveyPathParams {
    path?: Path;
    withBase?: boolean;
    surveyId?: SurveyId;
}

const getSurveyPath = (params?: GetSurveyPathParams) => {
    const {path, withBase, surveyId} = params ?? {};
    let result = '';

    if (withBase) {
        result = basePath;
    }

    if (preview) {
        result += '/' + routes.previewPath;
    }

    result += routes.surveyPath;

    if (path) {
        result += path;
    }

    if (surveyId) {
        result = generatePath(result, {surveyId});
    }

    return result;
};

export default getSurveyPath;
